var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":"Ayuda Komercia"}},[_c('button',{staticClass:"relative",on:{"click":function($event){return _vm.actionSelector()}}},[_c('img',{staticClass:"w-[18px]",attrs:{"loading":"lazy","src":require("../assets/information.webp"),"alt":"ImgInformation"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }